import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/svg_icons/fast-food.svg'
import _imports_1 from '@/assets/img/svg_icons/take-awayv3.svg'
import _imports_2 from '@/assets/img/moto.png'
import _imports_3 from '@/assets/img/cart.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "mfp-wrap mfp-close-btn-in mfp-auto-cursor my-mfp-zoom-in mfp-ready",
  tabindex: "-1",
  style: {"overflow":"hidden auto"}
}
const _hoisted_3 = { class: "mfp-container mfp-inline-holder" }
const _hoisted_4 = { class: "mfp-container mfp-inline-holder" }
const _hoisted_5 = { class: "mfp-content" }
const _hoisted_6 = {
  id: "modal-dialog",
  class: "modal-dialog-nonbackground"
}
const _hoisted_7 = {
  key: 0,
  class: ""
}
const _hoisted_8 = { class: "mt-2 mb-4 d-block title-select" }
const _hoisted_9 = { class: "opening-hours" }
const _hoisted_10 = { class: "opening-hours-table" }
const _hoisted_11 = { class: "title-select d-block" }
const _hoisted_12 = {
  class: "content",
  id: "sign-in-dialog"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "select-container-type" }
const _hoisted_15 = {
  key: 0,
  class: "options"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "100",
    height: "100"
  })
], -1)
const _hoisted_17 = { class: "col-12 select-type text-center" }
const _hoisted_18 = {
  key: 1,
  class: "options"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "100",
    height: "100"
  })
], -1)
const _hoisted_20 = { class: "col-12 select-type text-center" }
const _hoisted_21 = {
  key: 2,
  class: "options"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    width: "100",
    height: "100"
  })
], -1)
const _hoisted_23 = { class: "col-12 select-type text-center" }
const _hoisted_24 = { class: "row mt-3" }
const _hoisted_25 = {
  key: 0,
  class: "options"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    width: "100",
    height: "100"
  })
], -1)
const _hoisted_27 = { class: "col-12 select-type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "mfp-bg my-mfp-zoom-in mfp-ready",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_ctx.workTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("table", _hoisted_10, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("order.delivery")), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.openDeliveryMorning) + " - " + _toDisplayString(_ctx.closeDeliveryMorning), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.openDeliveryAfternoon) + " - " + _toDisplayString(_ctx.closeDeliveryAfternoon), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("order.takeaway")), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.openCACMorning) + " - " + _toDisplayString(_ctx.closeCACMorning), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.openCACAfternoon) + " - " + _toDisplayString(_ctx.closeCACAfternoon), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("order.eatin")), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.openMorning) + " - " + _toDisplayString(_ctx.closeMorning), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.openAfternoon) + " - " + _toDisplayString(_ctx.closeAfternoon), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("order.selectType")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            (_ctx.canEatIn && !_ctx.isDisabledAtPlace && _ctx.enabledQRCodeAtPlace)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("div", {
                                    class: "select-container",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOrderType('eatin')))
                                  }, [
                                    _hoisted_16,
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("order.eatinAction")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.canTakeOut && _ctx.enabledQRTakeOut)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("div", {
                                    class: "select-container",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOrderType('takeaway')))
                                  }, [
                                    _hoisted_19,
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("order.takeawayAction")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.canDelivery && !_ctx.idTable && _ctx.enabledQRCodeDelivery)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("div", {
                                    class: "select-container",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setOrderType('delivery')))
                                  }, [
                                    _hoisted_22,
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("order.deliveryAction")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          (_ctx.linkCart && _ctx.linkCart.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("div", {
                                  class: "select-container",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo(_ctx.linkCart)))
                                }, [
                                  _hoisted_26,
                                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("order.menu")), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}